import { apiFetch } from '@/api'
import { Type } from '@/interfaces'

export const fetchAllTypes = async (): Promise<Type> => (await apiFetch('/types', { method: 'GET' })).data
